import React from "react"
import ReactDatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { DateToText } from "../lib/dateFormat";
import InputGroup from 'react-bootstrap/InputGroup';

interface IProps {
    date: string | undefined; // 2000-01-31
    setDate: (newDate: string) => void; // setSate for date from parent component
    placeholder?: string;
}

interface IState {
    date: Date | undefined;
}

export class DatePicker extends React.Component<IProps, IState> {
    state = {
        date: this.props.date ? new Date(this.props.date) : undefined
    }

    handleSelect = (d: Date) => {
        const dateStr = DateToText(d);
        this.props.setDate(dateStr);
        this.setState({
            date: d
        })
    }

    handleChange = (d) => {
        const dateStr = DateToText(d);
        this.props.setDate(dateStr);
        this.setState({
            date: d ? d : undefined
        })
    }

    render() {
        return (
            <InputGroup className="datePickerWrapper">
                <InputGroup.Text onClick={(e) => {
                    e.currentTarget.nextElementSibling.getElementsByTagName("input")[0].dispatchEvent(new Event("click", {
                        bubbles: true,
                        cancelable: true,
                    }));
                }} >
                    <i className="fa-light fa-calendar-days"
                        />
                </InputGroup.Text>
                <div className="form-control">
                    <ReactDatePicker
                        dateFormat="MMM/dd/yyyy"
                        selected={this.state.date}
                        onSelect={this.handleSelect}
                        onChange={this.handleChange}
                        placeholderText={this.props.placeholder ?? null}
                    />
                </div>
            </InputGroup >
        )
    }
}